import { GoArrowLeft } from "react-icons/go";
import { MdAddCircleOutline } from "react-icons/md";

interface PopUpHeaderProps {
  title: string;
  handlePressBack: () => void;
  createNewOptions?: { text: string; onClick: () => void };
}

const PopUpHeader: React.FC<PopUpHeaderProps> = ({
  title,
  handlePressBack,
  createNewOptions,
}) => {
  return (
    <div className="self-stretch justify-between items-center inline-flex">
      <div className="justify-start items-center gap-3 flex">
        <button
          className="p-1.5 bg-neutral-50 rounded-full backdrop-blur-[32px] justify-center items-center flex cursor-pointer hover:bg-neutral-100 ease-in-out duration-150"
          onClick={handlePressBack}
          title="Come back to the previous step"
        >
          <GoArrowLeft className="w-5 h-5 fill-secondary-600" />
        </button>
        <div className="text-neutral-600 text-lg font-normal font-sans leading-snug select-none">
          {title}
        </div>
      </div>
      {createNewOptions && (
        <button
          className="group rounded justify-center items-center gap-2 flex cursor-pointer"
          onClick={createNewOptions.onClick}
          title={`${createNewOptions.text} button`}
        >
          <MdAddCircleOutline className="w-6 h-6 fill-secondary-600 group-hover:fill-secondary-700" />
          <div className="text-secondary-600 group-hover:text-secondary-700 text-lg font-semibold font-sans leading-snug">
            {createNewOptions.text}
          </div>
        </button>
      )}
    </div>
  );
};

export default PopUpHeader;
